// const host = 'dev-admin.connectoneauctions.com'; // dev
// const host = 'admin.circularfarms.com.au'; // prod
// const BASE_URL = 'bidding.yourservice.tips'
// const BASE_URL = 'dev-admin-app.c1io.com/'
// const host = 'dev-admin-app.c1io.com'
// const BASE_URL = 'kannikkattspices-admin.c1io.com'
// const host = 'kannikkattspices-admin.c1io.com'
  // const host = 'admin.bodicardamom.com';
  // const BASE_URL = 'admin.bodicardamom.com';
    // const host = 'admin.pcho.baistore.co.in';
    // const BASE_URL = 'admin.pcho.baistore.co.in';
    // const host = 'prcho-cone.cochq.au';
    // const BASE_URL = 'prcho-cone.cochq.au';
    // const host = 'prcho-aawk.cochq.au';
    // const BASE_URL = 'prcho-aawk.cochq.au';

    const host = location.host; 
    const BASE_URL = host;
export const environment = {
   firebase: 
  //  {
  //   databaseURL: 'https://connectone-test-default-rtdb.asia-southeast1.firebasedatabase.app/',
  //   projectId: 'connectone-test',
  //   apiKey:'AIzaSyCoXnLuiJvHU4s3JcPr3V-Z6SxaCbbBy7A',
  //   authDomain: "connectone-test.firebaseapp.com",
  //   storageBucket: "connectone-test.appspot.com",
  //   messagingSenderId: "492074490533",
  //   appId: "1:492074490533:web:815799fdbe1769010c0b4c",
  // },
  {
    databaseURL: 'https://connectone-prod-default-rtdb.asia-southeast1.firebasedatabase.app/',
    projectId: 'connectone-prod',
    apiKey: 'AIzaSyAFwqyHHhUjA6ylpjejyXv9bflae1jPGKQ',
    authDomain: "connectone-prod.firebaseapp.com",
    storageBucket: "connectone-prod.appspot.com",
    messagingSenderId: "77306820736",
    appId: "1:77306820736:web:733fa8a8514fc914938e65",
    measurementId: "G-RTTTFVZNF0"
  },
  production: false,
  orgId:'AGRI_CARD_VGCP_1',
  hostName: host,
  // orgId: '1',
  // baseUrl: 'https://api-admin-portal.connectoneauctions.com',
  // baseUrl: 'https://api-dev.yourservice.tips',
  // openBaseUrl: 'https://cdn-test.yourservice.tips',
  // customerBaseUrl: 'https://api-dev.yourservice.tips',
  api:
  BASE_URL.indexOf('www.') === 0 ? BASE_URL.replace('www.', '') : BASE_URL,
  // baseUrl: 'https://api-dev.c1io.com',
  // openBaseUrl: 'https://cdn-dev.c1io.com',
  // customerBaseUrl: 'https://api-dev.c1io.com',
  baseUrl: 'https://prod-api.cochq.au',
  openBaseUrl: 'https://prod-cdn-api.cochq.au',
  customerBaseUrl: 'https://prod-api.cochq.au',
  xNameNo: 'vtwo_dev_admin',
  streamApiKey: '4cq5uqeqwzsj',
  streamSecretKey: 'jva6dd58x8dhf3brgfuuc38nt2p9k7tfdzsj55wgp69caabmsj3udmmtvdwgvvu7', // Used for user creation only - move to backend in production
};
